import { PageController } from '@client/components/_core/layout/PageController';
import { ComplianceAuditTemplatePrincipleEdit } from '@client/components/compliance-audit-templates/ComplianceAuditTemplatePrincipleEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/admin-console/platform-content/compliance-audit-templates/details/$complianceAuditTemplateId/principles/add',
)({
    staticData: {
        presentation: 'overlay',
        metadata: { title: 'New principle' },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ComplianceAuditTemplatePrincipleEdit
                complianceAuditTemplateId={Route.useParams().complianceAuditTemplateId}
                action={['add']}
            />
        </PageController>
    );
}
